import React from 'react';

import { ComponentDto } from 'dto/raptor-component.dto';
import { ComponentVersionDto } from 'dto/raptor-component-version.dto';
import { TableUtils } from 'pages/private/components/table-utils';
import { RaptorComponentHelpers } from 'pages/private/software/raptor/components/helpers';
import { AdvanceTable, Select, Typography, useModal } from 'ui-lib';

import css from '../../deployment-create.css';

interface ISelectComponentVersionsStepProps {
    accountId: number;
    selectedComponents: ComponentDto[];
    availableVersions: Record<string, ComponentVersionDto[]>;
    selectedVersions: Record<string, ComponentVersionDto>;
    loading: boolean;
    onChange: (componentUuid: string, version: ComponentVersionDto) => void;
}

export const SelectComponentVersionsStep = (props: ISelectComponentVersionsStepProps): JSX.Element => {
    const [modal, contextHolder] = useModal();

    return (
        <React.Fragment>
            {contextHolder}
            <AdvanceTable
                title='Component versions'
                loadingState={props.loading}
                table={{
                    rowKey: 'uuid',
                    dataSource: props.selectedComponents,
                    columns: [
                        TableUtils.createBasicFilterColumn<ComponentDto>({ title: 'Component', key: 'name' }),
                        TableUtils.createBasicEnumFilterColumn<ComponentDto>({
                            title: 'Type',
                            key: 'type',
                            filters: Array.from(new Set(props.selectedComponents.map((component) => component.type))).map((type) => ({
                                text: type,
                                value: type,
                            })),
                        }),
                        TableUtils.createExtraColumn<ComponentDto>({
                            title: 'Version',
                            key: 'version',
                            render: (_, component: ComponentDto) => {
                                const versions = props.availableVersions[component.uuid] || [];
                                if (!versions.length) return <Typography.Text type='secondary'>No published versions available</Typography.Text>;
                                const selectedVersion = props.selectedVersions[component.uuid];
                                return (
                                    <div className={css.versionSelector}>
                                        <Select
                                            className={css.versionSelection}
                                            value={selectedVersion?.uuid}
                                            dataSource={versions.map((version) => ({
                                                label: version.version,
                                                value: version.uuid,
                                            }))}
                                            onChange={(versionUuid): void =>
                                                props.onChange(
                                                    component.uuid,
                                                    versions.find((version) => version.uuid === versionUuid),
                                                )
                                            }
                                        />
                                        <Typography.Link
                                            disabled={!selectedVersion}
                                            onClick={() => {
                                                RaptorComponentHelpers.showComponentVersionDetailsModal(modal, {
                                                    accountId: props.accountId,
                                                    componentVersionUuid: selectedVersion.uuid,
                                                });
                                            }}
                                        >
                                            View
                                        </Typography.Link>
                                    </div>
                                );
                            },
                        }),
                    ],
                }}
            />
        </React.Fragment>
    );
};
